/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAccountHistory.defs.js'
export * as $defs from './getAccountHistory.defs.js'
